import { render, staticRenderFns } from "./SitesList.vue?vue&type=template&id=533d495a&"
import script from "./SitesList.vue?vue&type=script&lang=js&"
export * from "./SitesList.vue?vue&type=script&lang=js&"
import style0 from "./SitesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports